// ========================================
// RAGE 3D - FLOATING PRODUCTS PREMIUM
// Atlantic Blue & Orange Theme
// Version 2.1 - iOS Fixed
// ========================================

(function() {
  'use strict';

  const CONFIG = {
    animationDuration: 300,
    hoverDelay: 100,
    touchFeedbackDuration: 150,
    intersectionThreshold: 0.1
  };

  let isTouch = false;
  let observers = [];

  function init() {
    detectTouchDevice();
    setupFloatingProducts();
    setupCollectionButton();
    setupIntersectionObserver();
    setupPerformanceOptimizations();
  }

  function detectTouchDevice() {
    isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (isTouch) document.documentElement.classList.add('touch-device');
  }

  function setupFloatingProducts() {
    const products = document.querySelectorAll('.floating-product');
    products.forEach((product) => {
      product.addEventListener('click', function(e) { handleProductClick(this, e); });
      if (isTouch) setupTouchFeedback(product);
      if (!isTouch) setupHoverEffects(product);
      setupLazyLoading(product);
    });
  }

  function handleProductClick(product, event) {
    const card = product.querySelector('.floating-product-card');
    if (card) {
      card.style.transform = 'scale(0.95)';
      setTimeout(() => { card.style.transform = ''; }, CONFIG.animationDuration);
    }
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({ 'event': 'product_click', 'product_id': product.dataset.productId });
    }
  }

  function setupTouchFeedback(product) {
    const info = product.querySelector('.floating-product-info');
    let touchTimer;
    product.addEventListener('touchstart', function() {
      if (info) { info.style.opacity='1'; info.style.visibility='visible'; info.style.transform='translateY(0)'; }
    }, { passive: true });
    product.addEventListener('touchend', function() {
      touchTimer = setTimeout(() => {
        if (info) { info.style.opacity='0'; info.style.visibility='hidden'; info.style.transform='translateY(10px)'; }
      }, 2000);
    }, { passive: true });
    product.addEventListener('touchcancel', function() {
      clearTimeout(touchTimer);
    }, { passive: true });
  }

  function setupHoverEffects(product) {
    let hoverTimer;
    product.addEventListener('mouseenter', function() {
      this.style.animationPlayState = 'paused';
      this.style.webkitAnimationPlayState = 'paused';
      hoverTimer = setTimeout(() => { this.classList.add('is-hovered'); }, CONFIG.hoverDelay);
    });
    product.addEventListener('mouseleave', function() {
      clearTimeout(hoverTimer);
      this.style.animationPlayState = 'running';
      this.style.webkitAnimationPlayState = 'running';
      this.classList.remove('is-hovered');
    });
  }

  function setupLazyLoading(product) {
    const image = product.querySelector('.floating-product-image');
    if (!image || !('IntersectionObserver' in window)) return;
    if (image.complete && image.naturalHeight !== 0) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { loadImage(image); observer.unobserve(entry.target); }
      });
    }, { rootMargin: '50px' });
    observer.observe(image);
    observers.push(observer);
  }

  function loadImage(image) {
    if (image.dataset.src) { image.src = image.dataset.src; image.removeAttribute('data-src'); }
  }

  function setupCollectionButton() {
    const button = document.querySelector('.collection-view-button');
    if (!button) return;
    button.addEventListener('click', function() {
      this.style.transform = 'translateY(-2px) scale(0.98)';
      setTimeout(() => { this.style.transform = ''; }, CONFIG.animationDuration);
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({ 'event': 'view_collection_click' });
      }
    });
    if (!isTouch) {
      button.addEventListener('mouseenter', function() { this.style.transform = 'translateY(-4px) scale(1.02)'; });
      button.addEventListener('mouseleave', function() { this.style.transform = ''; });
    }
  }

  function setupIntersectionObserver() {
    const container = document.querySelector('.floating-products-container');
    if (!container || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          entry.target.querySelectorAll('.floating-product').forEach((product, index) => {
            setTimeout(() => { product.style.opacity = '1'; }, index * 100);
          });
        }
      });
    }, { threshold: CONFIG.intersectionThreshold });
    observer.observe(container);
    observers.push(observer);
  }

  function setupPerformanceOptimizations() {
    ['https://cdn.shopify.com'].forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'preconnect'; link.href = domain; link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
    document.querySelectorAll('.floating-product').forEach((product, index) => {
      if (index < 2) {
        const image = product.querySelector('.floating-product-image');
        if (image && image.src) {
          const link = document.createElement('link');
          link.rel = 'prefetch'; link.as = 'image'; link.href = image.src;
          document.head.appendChild(link);
        }
      }
    });
    window.addEventListener('beforeunload', cleanup);
  }

  function cleanup() {
    observers.forEach(o => { if (o && o.disconnect) o.disconnect(); });
    observers = [];
  }

  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }

  window.addEventListener('resize', debounce(() => {
    const container = document.querySelector('.floating-products-container');
    if (container) container.style.height = '';
  }, 250));

  // ========================================
  // BURN EFFECT - iOS COMPATIBLE
  // ========================================

  (function initBurnEffect() {

    function attachBurn() {
      document.querySelectorAll('.floating-product').forEach(function(product) {
        if (product.dataset.burnReady) return;
        product.dataset.burnReady = 'true';

        var burnTimer = null;

        function startBurn() {
          if (burnTimer) { clearTimeout(burnTimer); burnTimer = null; }
          product.classList.add('is-burning');
          if (isTouch) {
            burnTimer = setTimeout(function() {
              product.classList.remove('is-burning');
              burnTimer = null;
            }, 3000);
          }
        }

        function stopBurn() {
          if (burnTimer) { clearTimeout(burnTimer); burnTimer = null; }
          product.classList.remove('is-burning');
        }

        // Desktop
        product.addEventListener('mouseenter', startBurn);
        product.addEventListener('mouseleave', stopBurn);

        // Touch - prodotto e card interna per iOS
        product.addEventListener('touchstart', function() {
          startBurn();
        }, { passive: true });

        var card = product.querySelector('.floating-product-card');
        if (card) {
          card.addEventListener('touchstart', function() {
            startBurn();
          }, { passive: true });
        }

      });
    }

    function tryAttach() {
      if (document.querySelectorAll('.floating-product').length > 0) {
        attachBurn();
      } else {
        var obs = new MutationObserver(function(m, o) {
          if (document.querySelectorAll('.floating-product').length > 0) {
            o.disconnect(); attachBurn();
          }
        });
        obs.observe(document.body, { childList: true, subtree: true });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tryAttach);
    } else {
      tryAttach();
    }

  })();

  // ========================================
  // AVVIO
  // ========================================

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.RageFloatingProducts = { refresh: init, cleanup: cleanup };

})();
